import {mapActions, mapState} from 'vuex';
import SessionStorage         from '../../lib/SessionStorage.js';

export const mobileAppBaseMixin = {
	data: () => ({
		mobileAppVersionRequired: '309000',
	}),

	created() {
		this.setAppType();
		this.addMobileAppListeners();
	},

	methods: {
		...mapActions(['refreshMobileApp', 'setAppType']),

		addMobileAppListeners() {
			if(this.isMobileApp) {
				if(this.isAndroidApp) {
					document.addEventListener('sendRegistrationToServer', this.sendRegistrationToServer, false);
					document.addEventListener('refreshMobileApp', this.refreshMobileApp, false);
				}
			}
		},

		sendRegistrationToServer(event) {
			const refreshToken = event.detail?.refreshToken;

			let UserAndroidToken = '';
			let isTokenRegistered = false;

			const isAuthenticated = this.Authenticated;

			this.$tryCatch({
				task: async () => {
					if(
						this.MobileApp !== undefined &&
						this.MobileApp.UserAndroidToken !== undefined &&
						this.MobileApp.UserAndroidToken !== ''
					) {
						UserAndroidToken = this.MobileApp.UserAndroidToken;
					}

					if (isAuthenticated && UserAndroidToken !== '') {
						if (UserAndroidToken !== SessionStorage.get('UserAndroidToken')) {
							await this.$http.post('/userandroidtoken', {
								UserAndroidToken,
								Refresh: refreshToken,
							});

							isTokenRegistered = true;
						}
					} else if (!isAuthenticated) {
						// obligatorisk "Login" för att kunna koppla enheten/token till användaren
					}
				},
				error(error) {
					isTokenRegistered = false;
				},
				finally() {
					SessionStorage.set('UserAndroidToken', UserAndroidToken);
					let reason = {
						Code:    0,
						Message: '',
					};
					if(!isTokenRegistered) {
						if (!isAuthenticated) {
							reason = {
								Code:    1,
								Message: 'Authentication required.',
							};
						} else if(UserAndroidToken === '') {
							reason = {
								Code:    2,
								Message: 'UserAndroidToken is empty.',
							};
						}
					}
					window.MobileApp.Android.sendRegistrationToServerResponse(isTokenRegistered, reason);
				},
			});
		},
	},

	computed: {
		...mapState([
			'isMobileApp',
			'isAndroidApp',
			'MobileApp',
		]),

		updateMobileApp() {
			//!!! OBS this.MobileApp inte satt ännu??? -> CPA-465 https://crona.atlassian.net/browse/CPA-465
			// return this.isMobileApp && (
			return window.CPA || (
				this.isMobileApp && (
					!window.MobileApp.Info ||
					(
						window.MobileApp.Info &&
						parseInt(window.MobileApp.Info.Version) < parseInt(this.mobileAppVersionRequired)
					)
				)
			);
		},
	},
}
